export const DEFAULT_MESSAGES = {
  pagination: {
    label: 'Pagination',
    page: 'Page',
    previous: 'Previous',
    next: 'Next',
    previousLabel: 'Go to previous page',
    nextLabel: 'Go to next page',
    firstLabel: 'Go to first page',
    lastLabel: 'Go to last page',
    goToLabel: (page: number) => `Go to page number ${page}`,
  },
  select: {
    empty: 'No results found',
  },
  colorPicker: {
    selectColor: 'Select color',
  },
  emptyState: {
    retry: 'Retry',
  },
  fileUploader: {
    chooseFile: 'Choose file',
    description: (formats: string, size: number) => `${formats}. Max size: ${size} MB.`,
    invalidSize: (size: number) => `File size exceeds the maximum limit of ${size} MB.`,
    invalidFormat: 'Unsupported file format.',
  },
  tree: {
    title: 'Collection',
  },
}

export type UiKitMessages = typeof DEFAULT_MESSAGES

export type UiKitMessageSection = keyof UiKitMessages

export type UiKitMessagesOverride = {
  [S in UiKitMessageSection]?: Partial<UiKitMessages[S]>
}
